import { createAxiosInstance } from "./api";
import initializeConfig from "./api.config";
import { interceptorAfterResponse } from "./api.interceptors";

const RequestNoCredentials = async () => {
  const { apiConfig, apimSubsKey } = await initializeConfig();
  const apiInstance = createAxiosInstance(apiConfig);

  interceptorAfterResponse(apiInstance);

  return {
    get: async (url: string, queryParams: any = {}) => {
      const config = {
        params: queryParams,
        headers: { "Ocp-Apim-Subscription-Key": apimSubsKey },
      };
      return apiInstance.get(url, config);
    },
    post: (url: string, data?: any) => {
      const config = {
        headers: { "Ocp-Apim-Subscription-Key": apimSubsKey },
      };
      return apiInstance.post(url, data, config);
    },
  };
};

export default RequestNoCredentials();
